import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/images/menu/logo.png'
import _imports_1 from '@/assets/images/menu/tokenflip.png'
import _imports_2 from '@/assets/images/menu/blackjack.png'
import _imports_3 from '@/assets/images/menu/hideandseek.png'
import _imports_4 from '@/assets/images/menu/rps.png'
import _imports_5 from '@/assets/images/menu/1v1.png'
import _imports_6 from '@/assets/images/menu/hazelnut.png'
import _imports_7 from '@/assets/images/menu/win.png'
import _imports_8 from '@/assets/images/menu/leaderboard.png'
import _imports_9 from '@/assets/images/menu/meme.png'
import _imports_10 from '@/assets/images/menu/topmeme.png'
import _imports_11 from '@/assets/images/menu/prevmeme.png'
import _imports_12 from '@/assets/images/menu/prevtopmeme.png'
import _imports_13 from '@/assets/images/menu/nft.png'
import _imports_14 from '@/assets/images/menu/stake.png'
import _imports_15 from '@/assets/images/menu/referrals.png'


const _hoisted_1 = { class: "sidebar-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "ElrondBet Games Logo",
  class: "img-fluid"
}, null, -1)
const _hoisted_3 = { class: "menu-container" }
const _hoisted_4 = { class: "menu-category" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Game Center", -1)
const _hoisted_6 = { class: "menu-item dropdown" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_8 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_9 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_11 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_12 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_14 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_15 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_17 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_18 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_20 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_21 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_23 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_24 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_26 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_27 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_29 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_30 = { class: "menu-category" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Community", -1)
const _hoisted_32 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_34 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_35 = { class: "menu-item dropdown" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_37 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("sup", { class: "pulsate" }, " NEW ", -1)
const _hoisted_39 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_9,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_41 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_42 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_10,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_44 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_45 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_47 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_48 = {
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    width: "20",
    height: "20"
  })
], -1)
const _hoisted_50 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_51 = { class: "menu-category" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Staking", -1)
const _hoisted_53 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_55 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_56 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_14,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_58 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_59 = {
  key: 0,
  class: "menu-category"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "category-title font-Baloo-Regular" }, "Account", -1)
const _hoisted_61 = {
  class: "menu-item",
  "data-bs-dismiss": "offcanvas",
  "data-bs-target": "#offcanvas"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "menu-icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_15,
    width: "24",
    height: "24"
  })
], -1)
const _hoisted_63 = { class: "menu-text font-Baloo-Regular" }
const _hoisted_64 = {
  key: 0,
  class: "account-wrapper"
}
const _hoisted_65 = {
  key: 1,
  class: "login-section"
}
const _hoisted_66 = /*#__PURE__*/_createStaticVNode("<div class=\"social-links\"><a href=\"https://twitter.com/token_nuts\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-twitter-x\"></i></a><a href=\"https://t.me/tokennuts\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-telegram\"></i></a><a href=\"https://discord.gg/UNKMB2TJRK\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-discord\"></i></a><a href=\"https://docs.elrondbet.net/\" target=\"_blank\" class=\"social-link\"><i class=\"bi bi-filetype-doc\"></i></a></div>", 1)
const _hoisted_67 = { class: "legal-footer" }
const _hoisted_68 = { class: "copyright-text" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("span", { class: "separator" }, "|", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SidebarAccount = _resolveComponent("SidebarAccount")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: _ctx.ROUTES.home },
      class: "sidebar-logo d-none d-lg-flex"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("a", {
            class: "menu-link dropdown-toggle",
            href: "#",
            role: "button",
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleGamesDropdown && _ctx.toggleGamesDropdown(...args)), ["prevent"])),
            ref: "dropdownToggleRef"
          }, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("menu.games")), 1),
            _createElementVNode("i", {
              class: _normalizeClass(['bi', 'ms-auto', 'menu-arrow', _ctx.isGamesDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'])
            }, null, 2)
          ], 512),
          _createElementVNode("ul", {
            class: _normalizeClass(["dropdown-menu games-dropdown", { 'show': _ctx.isGamesDropdownOpen }]),
            ref: "gamesDropdownRef"
          }, [
            _createElementVNode("li", _hoisted_9, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.blackjack },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.blackjack }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_10,
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("menu.blackjack")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_12, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.tokenFlip },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.tokenFlip }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("menu.tokenFlip")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_15, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.hideAndSeek },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.hideAndSeek }]),
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t("menu.hideAndSeek")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_18, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.rps },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.rps }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_19,
                  _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t("menu.rps")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_21, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.play1v1 },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.play1v1 }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isGamesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("menu.play1v1")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.nutsRoulette },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.nutsRoulette }])
          }, {
            default: _withCtx(() => [
              _hoisted_25,
              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("menu.nutsRoulette")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.raffle },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.raffle }])
          }, {
            default: _withCtx(() => [
              _hoisted_28,
              _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t("menu.raffle")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _hoisted_31,
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.leaderboard },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.leaderboard }])
          }, {
            default: _withCtx(() => [
              _hoisted_33,
              _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("menu.leaderboard")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("a", {
            class: "menu-link dropdown-toggle",
            href: "#",
            role: "button",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMemesDropdown && _ctx.toggleMemesDropdown(...args)), ["prevent"])),
            ref: "dropdownMemesToggleRef"
          }, [
            _hoisted_36,
            _createElementVNode("span", _hoisted_37, [
              _createTextVNode(_toDisplayString(_ctx.$t("menu.memes.title")) + " ", 1),
              _hoisted_38
            ]),
            _createElementVNode("i", {
              class: _normalizeClass(['bi', 'ms-auto', 'menu-arrow', _ctx.isMemesDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'])
            }, null, 2)
          ], 512),
          _createElementVNode("ul", {
            class: _normalizeClass(["dropdown-menu games-dropdown", { 'show': _ctx.isMemesDropdownOpen }]),
            ref: "memesDropdownRef"
          }, [
            _createElementVNode("li", _hoisted_39, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.meme.home },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.meme.home }]),
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isMemesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_40,
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("menu.memes.home")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_42, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.meme.listTop },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.meme.listTop }]),
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isMemesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_43,
                  _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t("menu.memes.top")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_45, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.meme.listOlder },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.meme.listOlder }]),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isMemesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_46,
                  _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$t("menu.memes.older")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ]),
            _createElementVNode("li", _hoisted_48, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.meme.listTopOlder },
                class: _normalizeClass(['dropdown-item', { active: _ctx.route.name === _ctx.ROUTES.meme.listTopOlder }]),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isMemesDropdownOpen = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_49,
                  _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t("menu.memes.topOlder")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _hoisted_52,
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.staking.nfts },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.staking.nfts }])
          }, {
            default: _withCtx(() => [
              _hoisted_54,
              _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t("menu.stakingNfts")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createVNode(_component_router_link, {
            to: { name: _ctx.ROUTES.staking.nuts },
            class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.staking.nuts }])
          }, {
            default: _withCtx(() => [
              _hoisted_57,
              _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.$t("menu.stakingNuts")), 1)
            ]),
            _: 1
          }, 8, ["to", "class"])
        ])
      ]),
      (_ctx.address)
        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.ROUTES.referrals },
                class: _normalizeClass(['menu-link', { active: _ctx.route.name === _ctx.ROUTES.referrals }])
              }, {
                default: _withCtx(() => [
                  _hoisted_62,
                  _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t("menu.referrals")), 1)
                ]),
                _: 1
              }, 8, ["to", "class"])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
          _createVNode(_component_SidebarAccount)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_65, [
          _createElementVNode("button", {
            class: "login-button font-Baloo-Regular",
            "data-bs-dismiss": "offcanvas",
            "data-bs-target": "#offcanvas",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.navigateToLogin && _ctx.navigateToLogin(...args)))
          }, _toDisplayString(_ctx.$t("menu.login")), 1)
        ])),
    _hoisted_66,
    _createElementVNode("div", _hoisted_67, [
      _createElementVNode("span", _hoisted_68, "© " + _toDisplayString(_ctx.currentYear) + " ElrondBet", 1),
      _hoisted_69,
      _createElementVNode("a", {
        href: "#",
        class: "legal-link",
        "data-bs-dismiss": "offcanvas",
        "data-bs-target": "#offcanvas",
        onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goToDisclaimer && _ctx.goToDisclaimer(...args)), ["prevent"]))
      }, " Disclaimer ")
    ])
  ]))
}